export const NOTES_CREATE_EDIT_OPEN_MODAL = "NOTES_CREATE_EDIT_OPEN_MODAL";
export const NOTES_CREATE_REQUEST = "NOTES_CREATE_REQUEST";
export const NOTES_CREATE_RESULT = "NOTES_CREATE_RESULT";
export const NOTES_UPDATE_REQUEST = "NOTES_UPDATE_REQUEST";
export const NOTES_UPDATE_RESULT = "NOTES_UPDATE_RESULT";
export const NOTES_GET_NOTE_REQUEST = "NOTES_GET_NOTE_REQUEST";
export const NOTES_GET_NOTE_RESULT = "NOTES_GET_NOTE_RESULT";
